<template>
    <div class="handwritten" id="handwritten">
        <div class="header">
            <span class="small-title">附表 1：</span>
            <h4 class="large-title">{{obj.tSignInfo.activityName}}报名表</h4>
        </div>
        <div class="border-box" >
            <div class="table-layout">
                <el-row type="flex">
                    <el-col :span="5" class="table-cell-title">检验检测机构名称</el-col>
                    <el-col :span="19" class="table-cell">{{obj.tSignInfo.orgName}}</el-col>
                </el-row>
                <el-row type="flex">
                    <el-col :span="5" class="table-cell-title">所属集团公司</el-col>
                    <el-col :span="19" class="table-cell">{{obj.tSignInfo.groupCompany}}</el-col>
                </el-row>
                <el-row type="flex">
                    <el-col :span="5" class="table-cell-title">检验检测机构资质情况</el-col>
                    <el-col :span="19" class="table-cell" style="justify-content: left !important;">
                        <div class="qualifications-box">
                            <div class="qualifications-item" style="margin-bottom:10px;">
                                <img src="../assets/checked.png" v-show="obj.tSignInfo.isMeasureAuth === 1"/>
                                <img src="../assets/no-checked.png" v-show="obj.tSignInfo.isMeasureAuth === 0"/>
                                <span style="margin:0 6px 0 0">已获计量认证</span>
                                <span style="margin:0 6px 0 0"  v-show="obj.tSignInfo.isMeasureAuth === 1">编号：{{obj.tSignInfo.measureAuthNo}}</span>
                            </div>
                            <div class="qualifications-item" style="margin-bottom:10px;">
                                <img src="../assets/checked.png" v-show="obj.tSignInfo.isMeasureAuth === 0"/>
                                <img src="../assets/no-checked.png" v-show="obj.tSignInfo.isMeasureAuth === 1"/>
                                <span>未获计量认证</span>
                            </div>
                            <div class="qualifications-item" style="margin-bottom:10px;">
                                <img src="../assets/checked.png" v-show="obj.tSignInfo.isLabAccept === 1"/>
                                <img src="../assets/no-checked.png" v-show="obj.tSignInfo.isLabAccept === 0"/>
                                <span style="margin:0 6px 0 0">已获实验室认可</span>
                                <span style="margin:0 6px 0 0" v-show="obj.tSignInfo.isLabAccept === 1">编号：{{obj.tSignInfo.labAcceptNo}}</span>
                            </div>
                            <div class="qualifications-item">
                                <img src="../assets/checked.png" v-show="obj.tSignInfo.isLabAccept === 0"/>
                                <img src="../assets/no-checked.png" v-show="obj.tSignInfo.isLabAccept === 1"/>
                                <span>未获实验室认可</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row type="flex">
                    <el-col :span="5" class="table-cell-title">实验室地址</el-col>
                    <el-col :span="19" class="table-cell">
                        {{obj.tSignInfo.labProvince}}
                        {{obj.tSignInfo.labCity}}
                        {{obj.tSignInfo.labArea}}
                        {{obj.tSignInfo.labAddress}}
                    </el-col>
                </el-row>
                <el-row type="flex">
                    <el-col :span="5" class="table-cell-title">样品/报告邮寄地址</el-col>
                    <el-col :span="19" class="table-cell">
                        {{obj.tSignInfo.postProvince}}
                        {{obj.tSignInfo.postCity}}
                        {{obj.tSignInfo.postArea}}
                        {{obj.tSignInfo.postAddress}}
                    </el-col>
                </el-row>
                <el-row type="flex">
                    <el-col :span="5" class="table-cell-title">联系人</el-col>
                    <el-col :span="7" class="table-cell">{{obj.tSignInfo.linkName}}</el-col>
                    <el-col :span="5" class="table-cell-title">联系电话</el-col>
                    <el-col :span="7" class="table-cell">{{obj.tSignInfo.linkMobile}}</el-col>
                </el-row>
                <el-row type="flex" style="margin-top:2px;">
                    <el-col :span="8" class="table-cell-title boderTop">项目名称</el-col>
                    <el-col :span="8" class="table-cell-title boderTop">试验方法</el-col>
                    <!-- <el-col :span="4" class="table-cell-title boderTop">标准费用</el-col> -->
                    <el-col :span="8" class="table-cell-title boderTop" v-show="obj.roleId == 1">用户价格</el-col>
                    <el-col :span="8" class="table-cell-title boderTop" v-show="obj.roleId == 2">专家价格</el-col>
                </el-row>
                <el-row type="flex" v-for="(item,index) in obj.tSignInfo.projects" :key="index">
                    <el-col :span="8" class="table-cell">{{item.projectName}}</el-col>
                    <el-col :span="8" class="table-cell">{{item.experimentMethod}}</el-col>
                    <!-- <el-col :span="4" class="table-cell">{{obj.tSignInfo.price}}</el-col> -->
                    <el-col :span="8" class="table-cell" v-show="obj.roleId == 1">{{item.price}}</el-col>
                    <el-col :span="8" class="table-cell" v-show="obj.roleId == 2">{{item.payPrice}}</el-col>
                </el-row>
                <div class="explain-box">
                    <h6 class="explain-title">说明：</h6>
                    <div class="explain-item">1. 中科名兽医注册用户报名9折，注册专家8折。</div>
                    <div class="explain-item">2. 各有关实验室应独立地完成实验室间比对项目的试验。</div>
                    <div class="explain-item">3. 新城疫病毒抗体检测项目样品为灭活血清，无生物安全风险。</div>
                    <div class="explain-item">4. 在实验室能力比对结果报告中，出于为参加者保密原因，均以参加机构代码表述。</div>
                    <div class="explain-item">5. 本报名表发送至邮箱beijinglab@sslab.com.cn。</div>
                    <div class="explain-item">
                        6. 付款信息：<br>
                        开户单位:北京中科基因技术股份有限公司<br>
                        开户银行:中国银行北京天河西路支行<br>
                        开户账户:338965276928<br>
                        注意事项:汇款时请在备注栏注明“检验检测机构名称+实验室间比对”。
                    </div>
                    <div class="explain-item" v-if="obj.tUserInvoice.id && obj.tUserInvoice.id">
                        7. 开票信息：<br>{{obj.tUserInvoice.invoiceType}}
                        开票类型（普票/专票）: {{obj.tUserInvoice.invoiceType === 2 ? '专票' : obj.tUserInvoice.invoiceType === 0 || obj.tUserInvoice.invoiceType === 1 ? '普票' : ''}}<br>
                        名称:{{obj.tUserInvoice.invoiceTitle}}<br>
                        税号:{{obj.tUserInvoice.ein}}<br>
                        单位地址:{{obj.tUserInvoice.theUnitAddress}}<br>
                        开户银行:{{obj.tUserInvoice.bank}}<br>
                        银行账户:{{obj.tUserInvoice.bankId}}<br>
                    </div>
                    <div class="explain-item textRight" style="padding-bottom: 20px;">
                        <span>检验检测机构负责人签名：</span>
                        <img :src="signUrl" v-show="signUrl"/>
                        <i v-show="!signUrl"></i>
                    </div>
                    <div class="explain-item textRight">
                        <span>{{year}}</span> 年
                        <span>{{month}}</span> 月
                        <span>{{date}}</span> 日
                    </div>
                </div>
            </div>
        </div>
        <div class="autograph-box" v-show="!signUrl">
            <div class="autograph-wrap">
                <div class="autograph-title">
                    <h5>签名 <strong>(请在有效区域内进行签名 并且确保签名清晰可辨)</strong></h5>
                </div>
                <canvas id="canvas" @touchstart.prevent="handleTouchStart" width="350" height="180" style="border:1px dashed #e3e3e3;">Canvas画板</canvas>
                <div class="tips">备注：签名以最后一次为准</div>
                <div class="button-box">
                    <button type="" @click.prevent="clear">清空签名</button>
                    <button @click.prevent="save">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as  API_ from '@/api/resetApi.js'
import { Notify, Toast } from 'vant';
var draw;
var preHandler = function(e){e.preventDefault();}
class Draw {
    constructor(el) {
        this.el = el
        this.canvas = document.getElementById(this.el)
        this.cxt = this.canvas.getContext('2d')
        this.stage_info = canvas.getBoundingClientRect()
        this.path = {
            beginX: 0,
            beginY: 0,
            endX: 0,
            endY: 0
        }
    }
    init(btn) {
        var that = this;
        this.canvas.addEventListener('touchstart', function(event) {
            document.addEventListener('touchstart', preHandler, true);
            that.drawBegin(event)
        })
        this.canvas.addEventListener('touchend', function(event) {
            document.addEventListener('touchend', preHandler, true);
            that.drawEnd()
        })
        this.clear(btn)
    }
    drawBegin(e) {
        var that = this;
        window.getSelection() ? window.getSelection().removeAllRanges() : document.selection.empty()
        this.cxt.strokeStyle = "#000"
        this.cxt.beginPath()
        this.cxt.moveTo(
            e.changedTouches[0].clientX - this.stage_info.left,
            e.changedTouches[0].clientY - this.stage_info.top
        )
        this.path.beginX = e.changedTouches[0].clientX - this.stage_info.left
        this.path.beginY = e.changedTouches[0].clientY - this.stage_info.top
        canvas.addEventListener("touchmove",function(event){
            that.drawing(event)
        })
    }
    drawing(e) {
        this.cxt.lineTo(
            e.changedTouches[0].clientX - this.stage_info.left,
            e.changedTouches[0].clientY - this.stage_info.top
        )
        this.path.endX = e.changedTouches[0].clientX - this.stage_info.left
        this.path.endY = e.changedTouches[0].clientY - this.stage_info.top
        this.cxt.stroke()
    }
    drawEnd() {
        document.removeEventListener('touchstart', preHandler, true);
        document.removeEventListener('touchend', preHandler, true);
        document.removeEventListener('touchmove', preHandler, true);
    }
    clear(btn) {
        this.cxt.clearRect(0, 0, 350, 180)
    }
    save(){
       return canvas.toDataURL("image/png")
    }

}
export default {
    data () {
        return {
           msg: 'Welcome to Your Vue.js App',
           val:true,
           url:'',
           signUrl:null,
           obj:{
               tUserInvoice:{},
               tSignInfo:{},
               experimentMethod:'',
               roleId:null
           },

           year:'',
           month:'',
           date:''
        }
    },
    created () {
        this.$nextTick(() => {
            window.onscroll = () =>{
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
                let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
                if(scrollTop + windowHeight >= scrollHeight) {
                }
            }
        })
        if(this.$route.query.utoken){
            localStorage.setItem('uToken', this.$route.query.utoken)
            this.getSignInfo()
        }

    },
    mounted () {
        draw=new Draw('canvas');
        draw.init();
    },
    methods: {
        async getSignInfo(){
            API_.activityGetSignInfo().then(res=>{
                if(res.data.code == 200){
                    this.obj.tSignInfo = res.data.data.tSignInfo
                    this.obj.tUserInvoice = res.data.data.tUserInvoice || {}
                    this.signUrl = this.obj.tSignInfo.signUrl
                    this.obj.roleId = res.data.data.roleId
                    this.obj.experimentMethod = res.data.data.experimentMethod
                    this.year = this.obj.tSignInfo.signTime ? this.obj.tSignInfo.signTime.slice(0,4) : ''
                    this.month = this.obj.tSignInfo.signTime ? this.obj.tSignInfo.signTime.slice(5,7) : ''
                    this.date = this.obj.tSignInfo.signTime ? this.obj.tSignInfo.signTime.slice(8,11) : ''
                }
            })
        },
        clear:function(){
            this.url = ''
            draw.clear();
        },
        save(){
            let c = document.getElementById('canvas')
            if(this.isCanvasBlank(c)){
                Toast('请签名')
            }else{
                let data=draw.save();
                this.url = data;
                this.obj.tSignInfo.signUrl = data
                this.activityEditSignInfo()
            }

        },
        isCanvasBlank(canvas){
            let blank = document.createElement('canvas');
            blank.width = canvas.width;
            blank.height = canvas.height;
            return canvas.toDataURL() == blank.toDataURL()
        },
        // 保存签名
        async activityEditSignInfo(){
            API_.activityEditSignInfo(this.obj.tSignInfo).then(res=>{
                if(res.data.code === 200){
                    this.signUrl = this.url
                    this.getSignInfo()
                    Toast('签名成功')
                    draw.clear();
                }
            }).catch(e=>{
                console.log(e)
            })
        },
        handleTouchStart(event){

        }
    }
}
</script>
<style scoped lang="scss">
.handwritten{
    overflow: hidden;
    position: relative;
    margin: 0;
    display: flex;
    font-size: 0;
    flex-direction: column;
    height: 100vh;
    .header{
        flex: none;
    }
}
.autograph-box{
    flex: none;
}
.qualifications-item{
    display: flex;
    img{
        width: 10px;
        height: 10px;
    }
    span{
        font-size: 12px;
        color: #606266;
    }
}
.explain-box{
    border-bottom: 1px solid #dcdfe6;
    border-right: 1px solid #dcdfe6;
    padding: 6px;
    .explain-title{
        font-size: 14px;
        text-align: left;
        font-weight: 600;
    }
    .explain-item{
        font-size: 14px;
        text-align: left;
        line-height: 20px;
        img{
            width: 120px;
            height: 60px;
        }
        i{
            display: inline-block;
            width: 120px;
            height: 60px;
        }
    }
    .textRight{
        text-align: right;
        padding-right: 20px;
        padding-bottom: 10px;
    }
}
.autograph-box{
    flex: none;
    height: 42vh;
    padding-bottom: 10px;
    .autograph-wrap{
        padding: 0 8px;
    }
    .autograph-title{
        border-bottom: 1px solid #eeeeee;
        padding:10px 0 8px 7px;
        margin-bottom: 4px;
        h5{
            display: block;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: justify;
            color: #181818;
            line-height: 16px;
            border-left: 2px solid #2784f8;
            padding-left: 10px;
            strong{
                font-size: 12px;
                font-family: PingFangSC, PingFangSC-Medium;
                color: #999999;
            }
        }

    }
    .tips{
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 20px;
        padding: 2px 12px;
    }
    .button-box{
        padding-bottom: 30px;
    }
    .button-box button:first-child{
        width: 108px;
        height: 38px;
        border: 1px solid #2574f6;
        border-radius: 23px;
        backdrop-filter: blur(10px);
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #2574f6;
        line-height: 25px;
        background: #ffffff;
        margin-right: 10px;
    }
    .button-box button:last-child{
        width: 108px;
        height: 38px;
        border: 1px solid #2574f6;
        border-radius: 23px;
        backdrop-filter: blur(10px);
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #fff;
        line-height: 25px;
        background: linear-gradient(315deg,#096fcb, #2784f8);
    }
}
.small-title{
    font-size: 14px;
    color: #999999;
    display: block;
    text-align: left;
    padding: 10px 10px 4px;
}
.large-title{
    font-size: 16px;
    font-weight: 600;
}
.border-box{
    overflow: auto;
    flex: auto;
    border: 1px solid #dcdfe6;
    margin: 10px 4px 0;
    // // height: 50vh;
    // overflow-y: auto;
}
.table-layout {
  margin: 2px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px 4px;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.boderTop{
    border-top: 1px solid #dcdfe6;
}

.table-cell-title {
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  font-size: 14px;
  color: #303133;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
